import { Link } from '@solidjs/meta';

export function BodoniModa()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400..900;1,6..96,400..900&display=swap' rel='stylesheet' />
	</>);
}

BodoniModa.fontFamily = '"Bodoni Moda", serif';
